import styled from 'styled-components/macro';

export const LegendContainer = styled.div`
  line-height: 15px;
`;
export const Item = styled.div`
  display: inline-block;
  font-size: 10px;
  margin-right: 5px;
`;
export const Title = styled.span`
  font-family: ${({ theme }) => theme.primaryFontBold};
`;
export const Description = styled.span`
  font-family: ${({ theme }) => theme.primaryFontLight};
  margin-left: 3px;
`;
